import React, { useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { IoTrashOutline } from "react-icons/io5";
import { LuPencilLine } from "react-icons/lu";
import AgregarProducto from './AgregarProducto';
import EditarProducto from './EditarProducto';
import { urlApiProd } from '../utiles';

const SearchBar = ({ filterText, onFilter }) => (
    <div className='input-group mb-3'>
        <input
            type="text"
            placeholder="Buscar..."
            value={filterText}
            onChange={onFilter}
            className='form-control'
        />
    </div>
);

const ActionButtons = ({ onAgregar }) => (
    <div className="input-group mb-3">
        <button type="button" className="btn btn-outline-primary" onClick={onAgregar}>Agregar Producto</button>
    </div>
);

const Productos = () => {
    const [dataProductos, setDataProductos] = useState([]);
    const [dataMedidas, setDataMedidas] = useState([]);
    const [opciones, setOpciones] = useState({
        categorias: [],
        especies: [],
        calidades: []
    });
    const firstRender = useRef(true);
    const [showAgregar, setShowAgregar] = useState(false);
    const [showEditar, setShowEditar] = useState(false);
    const [selected, setSelected] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [filteredData, setFilteredData] = useState([]);

    const fetchData = async () => {
        const token = localStorage.getItem('token'); // Obtener token de autenticación
        try {
            const productoResponse = await fetch(`${urlApiProd}/productos`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (productoResponse.status === 401) {
                throw new Error('Unauthorized');
            }
            const productoData = await productoResponse.json();
            setDataProductos(productoData);

            const opcionesResponse = await fetch(`${urlApiProd}/opciones`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (opcionesResponse.status === 401) {
                throw new Error('Unauthorized');
            }
            const opcionesData = await opcionesResponse.json();
            setOpciones(opcionesData);

            const medidasResponse = await fetch(`${urlApiProd}/medidas`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (medidasResponse.status === 401) {
                throw new Error('Unauthorized');
            }
            const medidasData = await medidasResponse.json();
            setDataMedidas(medidasData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (firstRender.current) {
            fetchData();
            firstRender.current = false;
        }
    }, []);

    useEffect(() => {
        if (Array.isArray(dataProductos)) {
            const filtered = dataProductos.filter((row) =>
                Object.values(row).some((value) =>
                    value.toString().toLowerCase().includes(filterText.toLowerCase())
                )
            );
            setFilteredData(filtered);
        }
    }, [dataProductos, filterText]);

    const columns = [
        {
            name: 'Editar',
            cell: (row) => (
                <button className='btn btn-outline-primary' onClick={() => handleEditar(row)}>
                    <LuPencilLine />
                </button>
            ),
            width: '80px',
        },
        {
            name: 'Categoría',
            selector: row => opciones.categorias.find(c => c.id_categoria === row.categoria)?.nombre || 'Desconocido',
            sortable: true,
        },
        {
            name: 'Especie',
            selector: row => opciones.especies.find(e => e.id_especie === row.especie)?.nombre || 'Desconocido',
            sortable: true,
        },
        {
            name: 'Calidad',
            selector: row => opciones.calidades.find(c => c.id_calidad === row.id_calidad)?.calidad || 'Desconocido',
            sortable: true,
        },
        {
            name: 'Medida',
            selector: row => {
                const m = dataMedidas.find(med => med.id_medida === row.medida);
                if (!m) return 'Desconocido';
                const e = parseInt(row.espesor) || 0;
                const a = parseInt(m.ancho) || 0;
                const l = parseInt(m.largo) || 0;
                return `${e} x ${a} x ${l}`;
            },
            sortable: true,
            grow: 1.5,
        },
        {
            name: 'NCM',
            selector: row => row.ncm,
            sortable: true,
        },
        {
            name: 'Nombre',
            selector: row => dataMedidas.find(m => m.id_medida === row.medida)?.medida || 'Desconocido',
            sortable: true,
        },
        {
            name: 'Eliminar',
            cell: (row) => (
                <button
                    className='btn btn-outline-danger'
                    onClick={() => {
                        if (window.confirm('¿Estas seguro?')) {
                            handleEliminar(row.id_producto);
                        }
                    }}
                >
                    <IoTrashOutline />
                </button>
            ),
            ignoreRowClick: true,
            width: '80px',
        },
    ];

    const handleAgregar = () => {
        setShowAgregar(true);
    };

    const handleEditar = (producto) => {
        setSelected(producto);
        setShowEditar(true);
    };

    const handleSaveEditar = (editedProducto) => {
        const token = localStorage.getItem('token'); // Obtener token de autenticación
        fetch(`${urlApiProd}/editarproducto/${editedProducto.id_producto}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(editedProducto),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Error al actualizar producto');
                }
                return response.json();
            })
            .then(data => {
                alert('Producto actualizado exitosamente');
                handleCloseEditar()
                fetchData();
            })
            .catch(error => {
                console.error('Error:', error);
            });
    };

    const handleCloseEditar = () => {
        setSelected(null);
        setShowEditar(false);
    };

    const handleEliminar = (idAEliminar) => {
        const token = localStorage.getItem('token'); // Obtener token de autenticación
        fetch(`${urlApiProd}/eliminarproducto/${idAEliminar}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        })
            .then(response => {
                if (response.ok) {
                    alert('Producto eliminado correctamente.');
                    fetchData();
                } else {
                    alert('Error al intentar eliminar producto.');
                }
            })
            .catch(error => {
                console.error('Error de red:', error);
            });
    };

    return (
        <div className='container-fluid'>
            <div className='card'>
                <div className='card-header'>
                    <h3 className='card-title' style={{ textAlign: 'center' }}>Productos</h3>
                </div>
                <div className='card-body mb-2'>
                    <SearchBar filterText={filterText} onFilter={(e) => setFilterText(e.target.value)} />
                    <ActionButtons onAgregar={handleAgregar} />
                    {showAgregar && <AgregarProducto cerrar={(nuevo) => {
                        setShowAgregar(false);
                        if (nuevo && nuevo.id_producto) {
                            fetchData();
                        }
                    }} opciones={opciones} medidas={dataMedidas} />}
                    <div className="card">
                        <div className="card-body">
                            <DataTable
                                columns={columns}
                                data={filteredData}
                                noHeader
                                responsive
                                pagination
                                highlightOnHover
                            />
                        </div>
                    </div>
                    {selected && showEditar && (
                        <EditarProducto
                            producto={selected}
                            medidas={dataMedidas}
                            cerrar={handleCloseEditar}
                            guardar={handleSaveEditar}
                            opciones={opciones}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Productos;
